import 'application/javascripts'
import listHover from 'application/javascripts/list_hover'
import 'application/images/nyu.svg';
import 'application/stylesheets'
require('turbolinks').start()

listHover()
